import { Component } from '@angular/core';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';

@Component({
  selector: 'app-formly-radio',
  templateUrl: './formly-radio.component.html',
  styleUrl: './formly-radio.component.scss',
})
export class FormlyRadioComponent extends FormlyFieldBaseComponent {}
